// FaltaView.js
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  InputBase,
  useTheme,
  Stack,
  Modal,
  Typography
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { getFaltas, getFaltasview, updateFaltas } from "../../services/faltas.services";
import ModalDeleteSuccess from "../../modal/modalDeleteSucces";
import ModalCharge from "../../modal/modalCharge";
import secureStorage from "../../utils/secureStorage";


const FaltasView = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openChargeModal, setOpenChargeModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openDeletedModal, setOpenDeletedModal] = useState(false);

  const [menu, setMenu] = useState("GENERAL");

  const [startDate, setStartDate] = useState(dayjs().startOf("month"));
  const [endDate, setEndDate] = useState(dayjs());

  // Aquí luego conectarás tu servicio real:
  const fetchData = async () => {
    try {
      const response = await getFaltasview(); // ← traer del backend
      setData(response);
      setFilteredData(response);
    } catch (error) {
      console.error("Error backend:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ⭐ Filtro principal
  useEffect(() => {
    let filtered = data;

    // Buscar por nombre/apellido
    filtered = filtered.filter((item) =>
        item.id_usuario?.toLowerCase().includes(searchValue.toLowerCase())
    );

    // Filtrar por menú seleccionado ("GENERAL" no filtra)
    if (menu === "AUSENCIA") {
      filtered = filtered.filter((item) => item.tipo === "AUSENCIA");
    }

    if (menu === "PERMISO_POR_DIA") {
      filtered = filtered.filter((item) => item.tipo === "PERMISO_POR_DIA");
    }

    if (menu === "PERMISO_POR_HORA") {
      filtered = filtered.filter((item) => item.tipo === "PERMISO_POR_HORA");
    }

    if (menu === "DESCONTAR") {
      filtered = filtered.filter((item) => item.tipo === "DESCONTAR");
    }


    // Filtrar rango de fechas
    filtered = filtered.filter((item) => {
  let fechaBase = null;

  if (item.tipo === "AUSENCIA" || item.tipo === "PERMISO_POR_DIA") {
    fechaBase = item.fecha_inicio;
  } else if (item.tipo === "PERMISO_POR_HORA") {
    fechaBase = item.hora_inicio;
  }  else if (item.tipo === "DESCONTAR") {
    fechaBase = item.fecha_inicio; 
  }  else {
    fechaBase = item.create_at;
  }

  if (!fechaBase || fechaBase === "0000-00-00 00:00:00") return false;

    const fecha = dayjs(fechaBase);
    return fecha.isSameOrAfter(startDate, "day") &&
        fecha.isSameOrBefore(endDate, "day");

});

    setFilteredData(filtered);
  }, [searchValue, menu, startDate, endDate, data]);

  // Columnas
    const columns = [
  { field: "id", headerName: "ID", width: 50 },
  { field: "id_usuario", headerName: "Empleado", flex: 1.5 },
  {
  field: "tipo",
  headerName: "Tipo",
  flex: 1,
  valueFormatter: (params) => {
    if (params.value === "PERMISO_POR_HORA") return "PERMISO POR HORA";
    if (params.value === "PERMISO_POR_DIA") return "PERMISO POR DÍA";
    return params.value;
  },
},


  {
    field: "fecha_inicio",
    headerName: "Fecha Inicio",
    flex: 1,
    renderCell: (p) =>
      p.value && p.value !== "0000-00-00 00:00:00"
        ? dayjs(p.value).format("DD/MM/YYYY")
        : "",
  },

  {
    field: "fecha_fin",
    headerName: "Fecha Fin",
    flex: 1,
    renderCell: (p) =>
      p.value && p.value !== "0000-00-00 00:00:00"
        ? dayjs(p.value).format("DD/MM/YYYY")
        : "",
  },

  {
    field: "hora_inicio",
    headerName: "Hora Inicio",
    flex: 1,
    renderCell: (p) =>
      p.value && p.value !== "0000-00-00 00:00:00"
        ? dayjs(p.value).format("DD/MM/YYYY HH:mm")
        : "",
  },

  {
    field: "hora_fin",
    headerName: "Hora Fin",
    flex: 1,
    renderCell: (p) =>
      p.value && p.value !== "0000-00-00 00:00:00"
        ? dayjs(p.value).format("DD/MM/YYYY HH:mm")
        : "",
  },

  { field: "dias", headerName: "Días", width: 50 },
  {
  field: "horas",
  headerName: "Horas",
  width: 50,
  valueFormatter: (params) => {
    const val = Number(params.value);
    return Number.isInteger(val) ? val : val.toFixed(2);
  },
},
{
  field: "descuento",
  headerName: "Descuento",
  flex: 1,
  valueFormatter: (params) => {
    const val = Number(params.value);
    return Number.isInteger(val) ? val : val.toFixed(2);
  },
},
    {
        field: "justificado",
        headerName: "Justificación",
        flex: 1,
        valueFormatter: (params) => {
            return params.value === 1 ? "Justificado" : "Injustificado";
        },
    },

    { field: "obs", headerName: "Observación", flex: 1.5 },
    { field: "created_by", headerName: "Creado por", flex: 1.5 },

    {
        field: "acciones",
        headerName: "Eliminar",
        width: 100,
        renderCell: (params) => (
          <IconButton
            color="error"
            onClick={() => {
              setSelectedRow(params.row);
              setOpenDeleteModal(true);
            }}
          >
            <DeleteIcon />
          </IconButton>
        ),
    },

];

 const confirmDelete = async () => {
    try {
        setIsLoading(true);
        const usuarioActual = secureStorage.getItem("id");
        await updateFaltas(selectedRow.id, { status_active: 0, updated_by: usuarioActual,  });
        
        
        setTimeout(() => {
            setIsLoading(false);         // cerrar spinner
            setOpenDeleteModal(false);   // cerrar modal de confirmación
            setSelectedRow(null);        // limpiar fila
            fetchData();                 // recargar lista
            setOpenDeletedModal(true);   // modal de éxito
        }, 2000);

    } catch (error) {
        setIsLoading(false);
        console.error("Error al eliminar:", error);
    }
  };

  return (
    <Box m="20px">

      <Header title="Relatorio de Faltas" subtitle="Gestión de Faltas y Permisos" />

      {/* ⭐ BUSCADOR + RANGO DE FECHAS */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        {/* Buscador */}
        <Box
            display="flex"
            backgroundColor={colors.primary[400]}
            borderRadius="3px"
            width="25%"
            height="40px"
            mb={2}
        >
          <InputBase
            sx={{ ml: 2, flex: 1 }}
            placeholder="Buscar por nombre..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <IconButton sx={{ p: 1 }}>
            <SearchIcon />
          </IconButton>
        </Box>

        {/* DatePickers */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Stack direction="row" spacing={2}>
            <DatePicker
              label="Fecha inicio"
              value={startDate}
              onChange={(v) => setStartDate(dayjs(v))}
              format="DD/MM/YYYY"
            />
            <DatePicker
              label="Fecha fin"
              value={endDate}
              onChange={(v) => setEndDate(dayjs(v))}
              format="DD/MM/YYYY"
            />
          </Stack>
        </LocalizationProvider>
      </Box>

       <Stack direction="row" spacing={2} mb={2}>
  <Button
    onClick={() => setMenu("GENERAL")}
    sx={{
      backgroundColor: menu === "GENERAL" ? "#cedc00" : "#373c4e",
      color: "#000", // texto negro para contraste
      fontSize: "15px",
      "&:hover": {
        backgroundColor: menu === "GENERAL" ? "#b8c600" : "#8f9600",
      },
    }}
  >
    General
  </Button>

  <Button
    onClick={() => setMenu("AUSENCIA")}
    sx={{
      backgroundColor: menu === "AUSENCIA" ? "#cedc00" : "#373c4e",
      color: "#000",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: menu === "AUSENCIA" ? "#b8c600" : "#8f9600",
      },
    }}
  >
    Ausencias
  </Button>

  <Button
    onClick={() => setMenu("PERMISO_POR_DIA")}
    sx={{
      backgroundColor: menu === "PERMISO_POR_DIA" ? "#cedc00" : "#373c4e",
      color: "#000",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: menu === "PERMISO_POR_DIA" ? "#b8c600" : "#8f9600",
      },
    }}
  >
    Permiso por Día
  </Button>

  <Button
    onClick={() => setMenu("PERMISO_POR_HORA")}
    sx={{
      backgroundColor: menu === "PERMISO_POR_HORA" ? "#cedc00" : "#373c4e",
      color: "#000",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: menu === "PERMISO_POR_HORA" ? "#b8c600" : "#8f9600",
      },
    }}
  >
    Permiso por Hora
  </Button>
  <Button
    onClick={() => setMenu("DESCONTAR")}
    sx={{
      backgroundColor: menu === "DESCONTAR" ? "#cedc00" : "#373c4e",
      color: "#000",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: menu === "DESCONTAR" ? "#b8c600" : "#8f9600",
      },
    }}
  >
    Descuento
  </Button>

</Stack>

      {/* ⭐ DATAGRID */}
      <Box
        height="70vh"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[900],
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
        }}
      >
        <DataGrid
          rows={filteredData}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
        />
      </Box>
        <Modal open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
  <>
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "#242b43",
        color: "#cedc00",
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
        width: 400,
      }}
    >
      <Typography variant="h6" mb={2}>
        Confirmar eliminación
      </Typography>

      <Typography mb={3}>
        ¿Estás seguro de querer eliminar el registro?
      </Typography>

      <Stack direction="row" spacing={2} justifyContent="flex-end">
        <Button
          onClick={() => setOpenDeleteModal(false)}
          sx={{
            bgcolor: "#4cceac",
            color: "#242b43",
            padding: "7px 10px",
            "&:hover": { bgcolor: "#3bbd9a" },
          }}
        >
          Cancelar
        </Button>

        <Button
          variant="contained"
          color="error"
          onClick={confirmDelete}
          sx={{
            bgcolor: "#ce4c4c",
            color: "#242b43",
            padding: "7px 10px",
            "&:hover": { bgcolor: "#ce3a3a" },
          }}
        >
          Eliminar
        </Button>
      </Stack>
    </Box>


    <ModalCharge isLoading={isLoading} />
  </>
</Modal>

        <ModalDeleteSuccess
            open={openDeletedModal}
            onClose={() => setOpenDeletedModal(false)}
            message="Eliminado con éxito"
        />

    </Box>
    
  );
};

export default FaltasView;
